// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_2787e5dfdf--checkbox--l9NIC","label":"_2787e5dfdf--label--wg3E4","box":"_2787e5dfdf--box--LEKeq","hasLabel":"_2787e5dfdf--hasLabel--uSvdq"};